import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Btn, H2, P } from '../AbstractElements';
import { EmailAddress, ForgotPasswordTitle, SendResetLink, ResendCode, ResendIn, BackToLogin } from '../Constant';
import AuthShell from './AuthShell';
import useCooldown from './useCooldown';
import API_BASE_URL from '../Config/api';

const COOLDOWN_SECONDS = 60;

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const { secondsLeft, start } = useCooldown();

    const requestReset = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error('Please enter your email address.');
            return;
        }
        setSending(true);
        try {
            await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email });
            setSent(true);
            start(COOLDOWN_SECONDS);
        } catch (error) {
            const retryAfter = error.response?.data?.retryAfterSeconds;
            if (retryAfter) start(retryAfter);
            toast.error(error.response?.data?.error || 'Could not send the reset email. Please try again.');
        } finally {
            setSending(false);
        }
    };

    return (
        <AuthShell>
            <Form className="theme-form">
                <H2 attrH2={{ className: 'text-center' }}>{ForgotPasswordTitle}</H2>
                <P attrPara={{ className: 'text-center' }}>
                    {sent
                        ? `If an account exists for ${email}, we've sent a password reset link and code to it.`
                        : "Enter your email and we'll send you a link and code to reset your password."}
                </P>
                {!sent && (
                    <Fragment>
                        <FormGroup className='form-group'>
                            <Label className="col-form-label">{EmailAddress}</Label>
                            <Input className="form-control" type="email" value={email} onChange={e => setEmail(e.target.value)} />
                        </FormGroup>
                        <div className='text-end mt-3'>
                            <Btn attrBtn={{ color: 'primary w-100', className: 'btn-block', disabled: sending, onClick: requestReset }}>
                                {sending ? 'Sending...' : SendResetLink}
                            </Btn>
                        </div>
                    </Fragment>
                )}
                {sent && (
                    <div className='text-center mt-2'>
                        <Btn attrBtn={{
                            color: 'link', className: 'p-0', type: 'button',
                            disabled: secondsLeft > 0 || sending,
                            onClick: requestReset,
                        }}>
                            {secondsLeft > 0 ? `${ResendCode} (${ResendIn} 00:${String(secondsLeft).padStart(2, '0')})` : ResendCode}
                        </Btn>
                    </div>
                )}
                <div className='text-center mt-4'>
                    <Link className="link" to='/login'>{BackToLogin}</Link>
                </div>
            </Form>
        </AuthShell>
    );
};

export default ForgotPassword;
